export const getQuestions = state => state.questions.questions;
export const getResult = state => state.questions.result;
export const getAnswers = state => state.questions.answers;
export const questionNumber = state => state.questions.questionNumber;
